import * as React from "react";
import { useCallback } from "react";
import { Formik, Form, Field } from "formik";
import mapValues from "lodash/mapValues";
import ArchiveBackendNameDescriptionFormGroup from "archive/components/ArchiveBackendNameDescriptionFormGroup";
import ArchiveBackendOutputPathFieldGroup from "archive/components/ArchiveBackendOutputPathFieldGroup";
import { FILESYSTEM_TYPE, S3_TYPE, GCS_TYPE, ABS_TYPE } from "archive/ArchiveStore";
import { FormSubmit, Select } from "components/common";
import { HelpBlock, Input } from "components/bootstrap";
import useHistory from "routing/useHistory";
import ArchiveBackendGCSFieldGroup from "archive/components/ArchiveBackendGCSFieldGroup";
import GCSSetupInfo from "components/gcs/GCSSetupInfo";
import ArchiveBackendS3FieldGroup from "archive/components/ArchiveBackendS3FieldGroup";
import AWSRegionsFormGroup from "archive/components/aws/AWSRegionsFormGroup";
import ArchiveBackendABSFieldGroup from "archive/components/ArchiveBackendABSFieldGroup";
const defaultFormValues = { title: "", description: "", settings: { type: void 0 } };
const BACKEND_TYPE_OPTIONS = [
  { value: FILESYSTEM_TYPE, label: "File system" },
  { value: S3_TYPE, label: "S3" },
  { value: GCS_TYPE, label: "GCS" },
  { value: ABS_TYPE, label: "Azure Blob" }
];
const _formatBackendValidationErrors = (backendErrors) => {
  const backendErrorStrings = mapValues(backendErrors, (errorArray) => `${errorArray.join(" ")}`);
  const { title, description, ...rest } = backendErrorStrings;
  return {
    title: title || void 0,
    description: description || void 0,
    settings: {
      ...rest
    }
  };
};
const BackendSpecificFields = ({ type }) => {
  switch (type) {
    case S3_TYPE:
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ArchiveBackendS3FieldGroup, null), /* @__PURE__ */ React.createElement(AWSRegionsFormGroup, null));
    case GCS_TYPE:
      return /* @__PURE__ */ React.createElement(ArchiveBackendGCSFieldGroup, null);
    case ABS_TYPE:
      return /* @__PURE__ */ React.createElement(ArchiveBackendABSFieldGroup, null);
    default:
      return null;
  }
};
const ArchiveBackendConfigForm = ({
  backend = {
    id: void 0,
    title: "",
    description: "",
    settings: {
      type: void 0
    }
  },
  submitButtonText,
  submitLoadingText,
  checkOutputPath,
  updateConfiguration,
  cancelURL
}) => {
  let initialValues;
  const history = useHistory();
  if (backend == null ? void 0 : backend.id) {
    const { id, title, description, settings } = backend;
    initialValues = { id, title, description, settings };
  } else {
    initialValues = defaultFormValues;
  }
  const _handleSubmit = (values, { setErrors }) => updateConfiguration(values).catch((error) => {
    var _a, _b;
    if (typeof ((_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.errors) === "object") {
      setErrors(_formatBackendValidationErrors(error.additional.body.errors));
    }
  });
  const onCancel = () => history.push(cancelURL);
  const resetBackendSpecificFields = useCallback((setFieldValue) => {
    const allBackendFields = {
      bucket: void 0,
      endpoint_uri: void 0,
      aws_access_key_id: void 0,
      aws_secret_access_key: void 0,
      aws_assume_role_arn: void 0,
      region: void 0,
      service_account: void 0,
      container: void 0,
      account_name: void 0,
      key: void 0,
      spool_directory: void 0
    };
    Object.entries(allBackendFields).forEach(([field, value]) => {
      setFieldValue(`settings.${field}`, value);
    });
  }, []);
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: _handleSubmit }, ({ values, setFieldValue, isSubmitting }) => {
    const resetFields = () => resetBackendSpecificFields(setFieldValue);
    return /* @__PURE__ */ React.createElement(Form, null, values.settings.type === GCS_TYPE && /* @__PURE__ */ React.createElement(GCSSetupInfo, null), /* @__PURE__ */ React.createElement(Field, { name: "settings.type" }, () => /* @__PURE__ */ React.createElement(
      Input,
      {
        help: "Select the Backend type you want to configure.",
        id: "default-backend-type-select",
        label: "Backend Type"
      },
      /* @__PURE__ */ React.createElement(
        Select,
        {
          id: "backendType",
          name: "BackendType",
          placeholder: "Select Backend Type",
          options: BACKEND_TYPE_OPTIONS,
          disabled: !!values.id,
          onChange: (option) => {
            resetFields();
            setFieldValue("settings.type", option);
          },
          value: values.settings.type
        }
      ),
      /* @__PURE__ */ React.createElement(HelpBlock, null)
    )), values.settings.type && /* @__PURE__ */ React.createElement(ArchiveBackendNameDescriptionFormGroup, null), values.settings.type && /* @__PURE__ */ React.createElement(BackendSpecificFields, { type: values.settings.type }), values.settings.type && /* @__PURE__ */ React.createElement(ArchiveBackendOutputPathFieldGroup, { checkOutputPath }), values.settings.type && /* @__PURE__ */ React.createElement(
      FormSubmit,
      {
        submitButtonText,
        submitLoadingText,
        isSubmitting,
        isAsyncSubmit: true,
        onCancel
      }
    ));
  });
};
export default ArchiveBackendConfigForm;
